export default __webpack_public_path__ + "static/media/image.suresh-bandara.e07f077a.png";